import React, { useEffect, useState } from "react";
import { FormControl, MenuItem, Select } from "@mui/material";
import { coreService } from "../../services/core.service";
import { useParams } from "react-router-dom";

const CompanyFilter = () => {
    const { company_id } = useParams();

    const [menuItems, setMenuItems] = useState<any[]>([]);
    const [hasUserForm, setHasUserForm] = useState<Boolean>(false);
    const [defaultCompanyId, setDefaultCompanyId] = useState<string>("0");

    const [SelectedMenuItem, setSelectedMenuItem] = useState(company_id);

    const handleInputChange = (e: any) => {
        const { value } = e.target;
        setSelectedMenuItem(value);
        window.location.replace(`/company/${value}`);
    };

    useEffect(() => {
        coreService.userCompany.subscribe((res) => {
            if (res[0] && res[0].id != 0) {
                setDefaultCompanyId(res[0].id)
                setMenuItems(res)
            }
        });

        coreService.userForm.subscribe((res) => {
            res[0] && setHasUserForm(true);
        });
    }, []);

    return (
        <div>
            <FormControl sx={{ width: 200 }} className="me-3">
                <Select variant="standard" value={SelectedMenuItem ? SelectedMenuItem : defaultCompanyId} label="Company" onChange={handleInputChange} name="company_id">
                    {(menuItems.length > 0 || hasUserForm) &&
                        menuItems.concat(hasUserForm ? [{id: '0', name: 'User Forms'}] : []).map((item: any) => (
                            <MenuItem key={item.id + item.name} value={item.id}>
                                {item.name}
                            </MenuItem>
                        ))}
                </Select>
            </FormControl>
        </div>
    );
};

export default CompanyFilter;
